<template>
  <div>
    <n-input v-if="editable" :value="value" @update:value="onUpdateValue" :placeholder="placeholder" :style="{ width: width }" />
    <div v-if="!editable" class="content flex-row-nowrap-start-start-center">{{ value }}</div>
  </div>
</template>
<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    value: string
    placeholder?: string
    editable?: boolean
    width?: string
  }>(),
  {
    editable: false,
  }
)
const emits = defineEmits<{
  "update:value": [value: string]
}>()

const onUpdateValue = (value: string) => {
  emits("update:value", value)
}
</script>
<style scoped>
.content {
  width: 100%;
  min-height: 34px;
}
</style>
